import { render } from "./SyllabusDialog.vue?vue&type=template&id=e0b88c3a&scoped=true"
import script from "./SyllabusDialog.vue?vue&type=script&lang=js"
export * from "./SyllabusDialog.vue?vue&type=script&lang=js"

import "./SyllabusDialog.vue?vue&type=style&index=0&id=e0b88c3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b88c3a"]])

export default __exports__